<template>
	<div class="car-filter">
		<div class="filter-bar-wrapper" ref="filterBar">
			<div
				:style="{
					position: filterFixed ? 'fixed' : 'unset',
					top: navHeight - 1 + 'px',
					background: '#FFF',
					zIndex: 1
				}"
			>
				<div class="filter-bar">
					<div class="filter-title">
						为你推荐
					</div>
					<div>
						<div
							class="sort-way"
							v-sd-clk:MallMktClick="{
								page: '二手车商城',
								page_source: pageSource,
								button_name: 'rank',
								track_sign: 'aMall.b22.d37.click.MallMktClick'
							}"
							@click="showSortWay = true"
							:class="{ active: config.sort !== 'default' }"
						>
							{{ sortWayLabel }}
							<i class="icon arrow-down" :class="{ expand: showSortWay }">
								<svg
									width="16"
									height="17"
									viewBox="0 0 16 17"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M14.5 5.78644L8 12L1.5 5.78644C1.89952 5.40452 2.54728 5.40452 2.9468 5.78644C2.9468 5.78644 2.9468 5.78644 2.9468 5.78644L8 10.6171L13.0532 5.78644C13.4527 5.40452 14.1005 5.40452 14.5 5.78643C14.5 5.78643 14.5 5.78643 14.5 5.78644Z"
										fill="currentColor"
									/>
								</svg>
							</i>
						</div>

						<div
							class="filter-txt"
							@click="openFilterPanel"
							v-sd-clk:MallMktClick="{
								page: '二手车商城',
								page_source: pageSource,
								button_name: 'filter',
								track_sign: 'aMall.b22.d39.click.MallMktClick'
							}"
							:class="{ active: filterActive }"
						>
							<span>筛选</span>
							<i class="icon arrow-down" :class="{ expand: showPanel }">
								<svg
									width="16"
									height="17"
									viewBox="0 0 16 17"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M14.5 5.78644L8 12L1.5 5.78644C1.89952 5.40452 2.54728 5.40452 2.9468 5.78644C2.9468 5.78644 2.9468 5.78644 2.9468 5.78644L8 10.6171L13.0532 5.78644C13.4527 5.40452 14.1005 5.40452 14.5 5.78643C14.5 5.78643 14.5 5.78643 14.5 5.78644Z"
										fill="currentColor"
									/>
								</svg>
							</i>
						</div>

						<div>
							<img
								class="filter-icon"
								:src="listTheme === 'normal' ? IconLargeMode : IconSmallMode"
								@click="$emit('update:listTheme', listTheme === 'normal' ? 'large' : 'normal')"
								v-sd-clk:MallMktClick="{
									page: '二手车商城',
									page_source: pageSource,
									button_name: 'view_type',
									track_sign: 'aMall.b22.d38.click.MallMktClick'
								}"
							/>
						</div>
					</div>
				</div>

				<div class="quick-tag-row">
					<div class="recommend-tags-row">
						<div class="recommend-tags-row-inner">
							<div
								v-for="tag in defaultTags"
								:key="tag.label"
								class="quick-tag"
								:class="{ active: tag.isActive() }"
								@click="onTagClick(tag)"
							>
								<img v-if="tag.label === '官方'" :src="IconNio" />
								{{ tag.label }}
							</div>

							<!-- <div
								v-for="tag in recommendTags"
								:key="tag.label"
								class="quick-tag"
								:class="{ active: tag.isActive() }"
								@click="onTagClick(tag)"
							>
								{{ tag.label }}
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>

		<portal to="sort-way">
			<nio-popup
				v-model="showSortWay"
				:closeOnClickOverlay="false"
				class="sort-menu"
				position="bottom"
				:overlayStyle="{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }"
			>
				<div class="sort-way-list">
					<div class="title-row">
						<div>排序</div>
						<div>
							<nio-icon name="icon_close_2xs" @click="showSortWay = false" :size="16" />
						</div>
					</div>
					<ul>
						<li
							v-for="way in allSortWays"
							:key="way.value"
							class="sort-way-item"
							:class="{ selected: way.value === config.sort }"
							v-sd-clk:MallMktClick="{
								page: '二手车商城',
								page_source: pageSource,
								button_name: way.label,
								requirement_id: 2015,
								track_sign: 'aMall.b22.d2240.click.MallMktClick'
							}"
							@click="changeConfig({ ...config, sort: way.value })"
						>
							<div>{{ way.label }}</div>
							<div class="select-icon">
								<svg
									width="16"
									height="17"
									viewBox="0 0 16 17"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M15 4.04037L5.74114 13.1547L5.74026 13.1556C5.61087 13.2818 5.40222 13.2814 5.27332 13.1547L1 8.9481C1.39331 8.56086 2.03106 8.56086 2.42441 8.94807C2.42442 8.94808 2.42443 8.94809 2.42441 8.94814L5.50635 11.9823L13.5755 4.04031C13.9689 3.65321 14.6066 3.65323 15 4.04037Z"
										fill="#00BEBE"
									/>
								</svg>
							</div>
						</li>
					</ul>
				</div>
			</nio-popup>
		</portal>
		<portal to="filter-panel">
			<nio-popup
				v-model="showPanel"
				:closeOnClickOverlay="false"
				position="bottom"
				:overlayStyle="{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }"
				class="filter-panel-popup"
			>
				<filter-panel
					ref="filterPanel"
					:visible="showPanel"
					:config="config"
					@change="changeConfig"
					@close="showPanel = false"
				/>
			</nio-popup>
		</portal>
	</div>
</template>

<script>
import FilterPanel from '@/views1/IndexPage/FilterPanel'
import IconLargeMode from '@/assets/svg/carhome/icon_large_list_s.svg'
import IconSmallMode from '@/assets/svg/carhome/icon_small_list_s.png'
import IconNio from '@/assets/svg/nioicon.svg'
import { allSortWays } from '@/views1/IndexPage/filterOptions'
import sensors from '@/util/dataTrack'

export default {
	name: 'CarFilter',
	components: { FilterPanel },
	props: {
		scrollTop: {
			type: Number,
			default: 0
		},
		config: {
			type: Object,
			required: true
		},

		listTheme: {
			type: String,
			default: 'normal'
		},
		navHeight: {
			type: Number,
			default: 0
		},
		tabName: {
			type: String,
			default: ''
		},
		selectedRecommends: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			IconLargeMode,
			IconSmallMode,
			IconNio,
			filterOffset: 0,
			filterShowLine: 0,

			// filterFixed: false,
			showPanel: false,

			showSortWay: false,

			allSortWays,

			defaultTags: [
				{
					label: '官方车源',
					isActive: this.isActive(1),
					onClick: this.genOnTagClick(1),
					hasDivider: true
				},
				{
					label: '个人车主',
					isActive: this.isActive(2),
					onClick: this.genOnTagClick(2),
					hasDivider: true
				},
				{
					label: '车商直售',
					isActive: this.isActive(4),
					onClick: this.genOnTagClick(4),
					hasDivider: true
				}
			]
		}
	},
	computed: {
		sortWayLabel() {
			if (this.config.sort) {
				const found = this.allSortWays.find(one => one.value === this.config.sort)
				if (found) {
					return found.label
				}
			}

			return '综合排序'
		},

		filterActive() {
			for (let key in this.config) {
				if (Array.isArray(this.config[key]) && this.config[key].length > 0) {
					if (
						key === 'sellers' &&
						this.config.sellers.length === 1 &&
						this.config.sellers[0] === 1
					) {
						// 如果只选中官方,按钮不高亮
						continue
					}
					return true
				}
			}
			return false
		},
		filterFixed() {
			return this.scrollTop > this.filterShowLine
		},
		pageSource() {
			return this.$route.query.page_source;
		}
	},
	watch: {
		scrollTop() {
			this.$nextTick(() => {
				if (this.$refs && this.$refs.filterBar) {
					this.filterOffset = this.$refs.filterBar.offsetTop || 0;
					this.filterShowLine = this.filterOffset - this.navHeight;
				}
			})
		},
	},
	methods: {
		isActive(type) {
			return () => this.config.sellers.includes(type)
		},
		genOnTagClick(type) {
			return (isActive, config) => {
				config.sellers = config.sellers || []

				if (isActive) {
					config.sellers = config.sellers.filter(one => one !== type)
				} else {
					config.sellers.push(type)
				}
			}
		},
		openFilterPanel() {
			this.showPanel = true
		},
		changeConfig(newConfig) {
			this.$emit('update:config', { ...newConfig })

			this.$nextTick(() => {
				this.showSortWay = false
			})
		},
		switchCarTypes(carType, isActive, config) {
			if (isActive) {
				config.carTypes = config.carTypes.filter(one => one !== carType)
			} else {
				config.carTypes.push(carType)
			}
		},
		onTagClick(tag) {
			if (!tag.isActive()) {
				sensors.track('MallMktClick', {
					page: '二手车商城',
					tab_name: tag.label,
					track_sign: tag.track_sign,
					mkt_in_type: 'quick_filter'
				})
			}
			tag.onClick(tag.isActive(), this.config)

			this.$nextTick(() => {
				const selectedArr = []

				// ;[...this.defaultTags, ...this.recommendTags].forEach(tag => {
				;[...this.defaultTags].forEach(tag => {
					if (tag.isActive()) {
						selectedArr.push(tag.label)
					}
				})

				this.$emit('update:selectedRecommends', selectedArr)
			})
		}
	}
}
</script>

<style scoped lang="scss">
@import '~@nio-fe/nio-app-ui/es/style';

@keyframes barAppear {
	from {
		transform: translateY(-60px);
	}
	to {
		transform: translateY(0px);
	}
}

.car-filter {
	margin-bottom: 10px;
	background-color: #ffffff;

	//display: flex;
	//justify-content: space-between;
	//align-items: center;

	.filter-title {
		@include headline_4();

		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.sort-way {
		margin-right: 15px;

		&.active {
			color: $text_basic_active;
		}
	}

	.filter-bar-wrapper {
		width: 100vw;
		background-color: #ffffff;
		z-index: 1;
		height: 89px;
	}

	.filter-bar {
		width: 100vw;
		height: 44px;

		@include subtitle_4(1.4, 400, false);
		z-index: 100;

		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 0 20px 0;
		align-items: center;

		> :last-child {
			display: flex;
			align-items: center;

			> div {
				display: flex;
				align-items: center;
			}
		}

		.filter-icon {
			width: 16px;
			height: 16px;
		}
		.filter-divider {
			display: inline-block;
			width: 1px;
			height: 10px;
			background-color: $text_disable;
			margin-left: 10px;
			margin-right: 10px;
		}

		.filter-txt {
			margin-right: 15px;
			&.active {
				color: $text_basic_active;
			}
		}

		.icon {
			display: inline-flex;
			align-items: center;
			margin-left: 5px;

			&.arrow-down {
				margin-left: 6.5px;
				transform-origin: center center;

				&.expand {
					transform: rotate(180deg);
				}
			}

			&.open-filter {
				margin-right: 6.5px;

				&.active {
					font-weight: bold;
				}
			}
		}
	}
}

.quick-tag-row {
	width: 100vw;
	overflow-x: auto;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 15px 20px 10px 20px;

	.quick-tag {
		flex-grow: 0;
		flex-shrink: 0;
		padding: 0 10px;
		height: 30px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		@include body_2();
		color: $text_primary;
		border: 1px solid #ebecee;

		img {
			width: 12px;
			margin-right: 5px;
		}
		&.active {
			border-color: $border_primary;
		}

		&:not(:last-child) {
			margin-right: 10px;
		}
	}

	.tag-divider {
		margin: 0 15px 0 5px;
		height: 15px;
		border-right: 1px solid #e9ecf1;
	}

	.recommend-tags-row {
		flex: 1;

		height: 30px;
		overflow-x: auto;
		overflow-y: hidden;

		&-inner {
			width: 100%;
			height: 35px;
			display: flex;
			overflow-x: auto;
			flex-wrap: nowrap;
			// justify-content: space-between; /** 暂时平铺*/
			align-items: flex-start;
		}
	}
}
</style>
